<template>
    <header :class="{ 'left-shift': showMenu, 'pinned': pinned }">
        <div class="header-logo">
            <p class="visuallyhidden">
                ACET Checkin Logo
            </p>
        </div>
        <a class="header-skiplink visuallyhidden focusvisible" href="#content">
            <span>Skip To Main Content</span>
        </a>
        <div class="header-search">
            <search-bar />
        </div>
        <div v-if="current && current.role.id == 1" class="header-switcher">
            <label for="switch-school" class="visuallyhidden"> Switch School</label>
            <app-select
                id="switch-school" 
                v-model="school" 
                title="Switch School">
                <app-option
                    v-for="item in schools"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
            </app-select>
        </div>
        <div v-if="current" class="header-user header-dropdown">
            <div class="header-profile" aria-haspopup="true" tabindex="0">
                <div class="header-profile-name">
                    Hello,
                    <strong>{{ fullName }}</strong>
                </div>
                <div class="header-profile-role">
                    {{ roleName }}
                </div>
            </div>
            <ul class="dropdown" aria-label="submenu">
                <li>
                    <router-link :to="{ name: 'users.detail', params: { id: current.id } }">
                        Profile
                    </router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'logout' }">
                        Logout
                    </router-link>
                </li>
            </ul>
        </div>
        <button class="header-menu-button" tabindex="0" @click="toggleMenu">
            <i class="el-icon-menu" />
            <span>Menu</span>
        </button>
    </header>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { get } from '../../utilities'
import SearchBar from '../ui/SearchBar'
export default {
    name: 'navbar',
    components: {
        SearchBar
    },
    data() {
        return {
            pinned: false
        }
    },
    computed: {
        ...mapState({
            current: ({ me }) => me.current,
            schools: ({ params }) => params.schools,
            showMenu: ({ params }) => params.showMenu
        }),
        ...mapGetters(['fullName', 'roleName']),
        school: {
            get() {
                return get(this, 'current.school_id')
            },
            set(val) {
                this.switchSchool({ schoolId: val }).then(() => {
                    this.$router.push({ name: 'home' })
                    location.reload()
                })
            }
        }
    },
    created() {
        this.getParams()
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed: function() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        ...mapActions(['getParams', 'switchSchool']),
        toggleMenu() {
            this.$store.commit('TOGGLE_MENU')
        },
        handleScroll: function() {
            this.pinned = document.body.scrollTop > 10
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

header
    background: $lighter-grey
    position: fixed
    top: 0px
    left: 0px
    width: 100%
    height: 80px
    z-index: 999
    display: flex
    transition: all 0.25s
    border-bottom: 1px solid $light-border-color

    &.left-shift
        transform: translate(-160px, 0px)

    &.pinned
        background: $white
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1)
        border-bottom-color: transparent

    .header-menu-button
        width: 65px
        display: none
        flex-direction: column
        text-align: center
        background: $darker-grey
        color: $white
        align-items: center
        justify-content: center
        font-size: 14px
        border: 0px solid transparent
        margin: 0px
        cursor: pointer
        flex-shrink: 0
        border-radius: 0px

        span
            padding-top: 3px
            display: block

        i
            font-size: 24px

    .header-logo
        width: 80px
        height: 80px
        background-image: url('../../assets/svg/logo_shaded.svg')
        background-size: 80% 80%
        background-position: center center
        background-repeat: no-repeat
        background-color: $medium-blue
        flex-grow: 0
        flex-shrink: 0

    .header-skiplink
        display: flex
        text-align: center
        align-items: center
        line-height: 100%
        flex-direction: row
        justify-content: center
        padding: 10px !important

        span
            vertical-align: middle

    .header-search
        flex-grow: 1
        padding: 10px 0 10px 20px
        position: relative

    .header-switcher
        padding: 12px 15px
        border-left: 1px solid $light-border-color
        margin: 8px 0

        .app-select
            input
                border-radius: 6px

    .header-user
        padding: 9px 20px 7px 0
        border-left: 1px solid $light-border-color
        margin: 8px 0

    .header-profile
        padding: 7px 0 6px 10px
        margin: 0 20px 0px 10px
        color: $text-dark-grey
        cursor: pointer

        .header-profile-role
            font-size: 12px
            color: $text-medium-grey
            padding: 2px 0px

    .header-dropdown
        display: block
        float: left
        position: relative
        text-decoration: none
        transition-duration: 0.5s

        a
            display: block
            cursor: pointer
            text-decoration: none

            &:hover, &:focus
                background: $dark-blue
                color: $white

        &:hover, &:focus-within
            cursor: pointer

        &:focus-within a
            outline: none

        ul
            border-radius: 10px
            box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1)
            list-style: none
            margin: 0
            padding-left: 0
            padding-top: 6px
            padding-bottom: 6px
            background: $white
            visibility: hidden
            opacity: 0
            min-width: 5rem
            position: absolute
            transition: all 0.5s ease
            left: 5%
            width: 80%
            display: none
            overflow: hidden

            li
                padding: 0px 6px

            a
                padding: 8px 10px
                border-bottom: 1px solid $light-border-color
                color: $dark-blue

                &:hover, &:focus
                    border-radius: 8px

            li:last-child a
                border-bottom: 0px

        &:hover > ul, &:focus-within > ul, ul:hover, ul:focus
            visibility: visible
            opacity: 1
            display: block

    @media screen and (max-width: 1024px)
        height: 70px

        .header-logo
            width: 70px
            height: 70px

        .header-search
            padding: 10px 0px 10px 20px

        .header-switcher
            padding: 12px 15px
            border-left: 1px solid $border-color
            margin: 8px 0
            .app-select
                input
                    border-radius: 6px
        .header-user
            padding: 9px 20px 7px 0
            border-left: 1px solid $border-color
            margin: 8px 0
        .header-profile
            padding: 2px 0px 6px 10px

    @media screen and (max-width: 480px)
        height: 70px

        .header-switcher
            display: none

        .header-menu-button
            display: flex

        .header-logo
            width: 60px
            height: 70px

        .header-search
            padding: 5px 0px 0px 10px

        .header-profile
            display: none
</style>
